import React, { ReactNode, useEffect, useState } from "react";
import { SideBar } from "./SideBar";
import Navbar from "./Navbar";
import logo from "../assets/images/navlogo.png"; // Import your logo image
import { useAppSelector } from "@/hooks/hook";
import { useLocation } from "react-router";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { currentBusinessOwnerCardStatus, currentBusinessOwnerCustomerId, currentBusinessOwnerNameSave, currentBusinessSave } from "@/redux/slices/businessSlice";
import { useDispatch } from "react-redux";
import SearchSelect from "@/components/StyledSelect/SearchSelect";

interface DashboardLayoutProps {
  children?: ReactNode;
}
interface User {
  first_name: string;
  last_name: string;
  roles: string;
  // Add other properties of the user object if available
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const location = useLocation();
  // const { user } = useAppSelector((store) => ({
  //   user: store.user.user as User,
  // }));
  const user = useAppSelector((store) => store.user);
  const billing = useAppSelector((store) => store.billing.billingDetails);
  const { refreshToken, business_id, first_name, last_name, roles, customerId, card } =
    useAppSelector((store) => store.user);
  const [comapniesData, setComapniesData] = useState<Array<any>>([]);
  const [currentBusiness, setCurrentBusiness] = useState<any>({
    id: business_id,
    name: "Business",
    first_name: "",
    last_name: "",
    customerid: "",
    card_status: false
  });
  const dispatch = useDispatch();
  const { getActiveCompanyApi } = API_ROUTES;

  useEffect(() => {
    (async () => {
      if (user?.email) {
        try {
          const result = await GET(getActiveCompanyApi, refreshToken);
          if (result.data) {
            setComapniesData(result.data);
            if (user.roles === 'admin') {
              setCurrentBusiness(
                result.data.find((b: any) => b.id === business_id)
              );
            }
            else {
              setCurrentBusiness((prev: any) => ({
                ...prev, id: business_id,
                first_name: first_name,
                last_name: last_name,
                customerid: customerId,
                card_status: card
              }));
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, [user]);
  useEffect(() => {
    if (currentBusiness) {
      dispatch(currentBusinessSave(currentBusiness.id));
      dispatch(currentBusinessOwnerCustomerId(currentBusiness?.customerid))
      dispatch(currentBusinessOwnerCardStatus(currentBusiness?.card_status))
      const fullName = [currentBusiness?.first_name, currentBusiness?.last_name].filter(Boolean).join(" ");
      if (fullName) {
        dispatch(currentBusinessOwnerNameSave(fullName));
      }
    }
  }, [currentBusiness]);

  function getGreetingMessage() {
    const currentHour = new Date().getHours(); // Get the current hour (0-23)
    let greeting;

    if (currentHour < 12) {
      greeting = "Good morning";
    } else if (currentHour < 18) {
      greeting = "Good afternoon";
    } else {
      greeting = "Good evening";
    }

    return greeting;
  }

  return (
    <>
      {<div className="h-full ">
        {billing?.subscription_status === 'past_due' && user.roles !== 'admin' && <div className="bg-primary-red p-2 text-sm text-white text-center">
          <p>Payment due! Settle now for uninterrupted access. Thank you!</p>
        </div>}
        <div className="flex  h-full  justify-between  ">
          <SideBar />
          <div className=" pb-10 w-full lg:w-10/12  ">
            <Navbar />
            {(location.pathname === "/billing" ||
              location.pathname === "/dashboard") && (
                <div className="bg-white p-4 flex items-center justify-between flex-wrap">
                  <p className="text-xl font-semibold">
                    {getGreetingMessage()}{" "}
                    <span className="text-primary-red">
                      {first_name.charAt(0).toUpperCase() +
                        first_name.slice(1).toLowerCase() +
                        " " +
                        last_name.charAt(0).toUpperCase() +
                        last_name.slice(1).toLowerCase()}
                    </span>{" "}
                  </p>
                  <div className="w-full sm:w-auto mt-4 sm:mt-0">
                    {roles == "admin" && (
                      <div className="w-full flex justify-center sm:justify-end mt-5">
                        <SearchSelect
                          options={comapniesData}
                          value={{ name: currentBusiness?.name, id: currentBusiness?.id }}
                          onChange={(selectedValue) => {
                            setCurrentBusiness(selectedValue);
                          }}
                          data-testid="search-id"
                          placeholder={"Select Business"}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            <div className="px-5 rounded-2xl bg-p-gray pb-10  top-36">
              {children}
            </div>
          </div>
          {/* rightbar */}
          <div className="w-10 bg-white hidden lg:block "></div>
        </div>
      </div>}
    </>

  );
};

export default DashboardLayout;
